;(function(){
  'use strict';
  if(window.__SHRegionalAdapterV109)return;
  window.__SHRegionalAdapterV109=true;

  var UK_COUNTRIES='|GB|IE|MT|CY|';
  var US_COUNTRIES='|US|CA|';
  var AU_COUNTRIES='|AU|NZ|';
  var EU_COUNTRIES='|AT|BE|BG|HR|CZ|DK|EE|FI|FR|DE|GR|HU|IT|LV|LT|LU|NL|PL|PT|RO|SK|SI|ES|SE|IS|NO|CH|';
  var LEGACY_ROOT='[data-sh-lighting-editorial],[data-sh-trending-editorial],[data-sh-home-accessories],[data-sh-textile-architecture],[data-sh-art-poster-index],[data-sh-furniture-room-anchors]';
  var LEGACY_DATA='[data-sh-product-data],[data-sh-furniture-products]';
  var bootTimer=0;

  function text(value){return String(value==null?'':value).trim();}
  function lower(value){return text(value).toLowerCase();}
  function countryCode(root){
    var code=root&&root.dataset&&root.dataset.country;
    if(!code&&window.SH_CRO_CONTEXT)code=window.SH_CRO_CONTEXT.market;
    if(!code&&window.Shopify)code=window.Shopify.country;
    return text(code).toUpperCase();
  }
  function preferredRegion(root){
    var code=countryCode(root),token='|'+code+'|';
    if(UK_COUNTRIES.indexOf(token)!==-1)return'UK';
    if(US_COUNTRIES.indexOf(token)!==-1)return'US';
    if(AU_COUNTRIES.indexOf(token)!==-1)return'AU';
    if(EU_COUNTRIES.indexOf(token)!==-1)return'EU';
    return'';
  }
  function regionFromValue(value){
    var probe=lower(value);
    if(!/(?:plug|adapter)/i.test(probe)||/\busb\b/i.test(probe))return'';
    var match=probe.match(/\b(uk|us|eu|au)\b/i);
    return match?match[1].toUpperCase():'';
  }
  function baseValue(value){
    return lower(value)
      .replace(/\b(?:uk|us|eu|au)\b/g,' ')
      .replace(/\b(?:plug|adapter)\b/g,' ')
      .replace(/[^a-z0-9]+/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  }
  function optionValue(entry){
    if(entry&&typeof entry==='object'){
      if(entry.value!=null)return text(entry.value);
      if(entry.name!=null)return text(entry.name);
    }
    return text(entry);
  }
  function variantOptions(variant){
    return Array.isArray(variant&&variant.options)?variant.options.map(optionValue):[];
  }
  function available(variant){return !!variant&&variant.available!==false;}
  function optionName(product,index){
    var option=product&&Array.isArray(product.options)?product.options[index]:null;
    if(option&&typeof option==='object'&&option.name!=null)return text(option.name);
    if(typeof option==='string')return option;
    return'';
  }
  function detectPlugIndex(product,variants){
    var count=0;
    (variants||[]).forEach(function(variant){count=Math.max(count,variantOptions(variant).length);});
    if(product&&Array.isArray(product.options))count=Math.max(count,product.options.length);
    for(var index=0;index<count;index+=1){
      var name=lower(optionName(product,index));
      var regional=0;
      var powered=0;
      (variants||[]).forEach(function(variant){
        var value=variantOptions(variant)[index]||'';
        if(regionFromValue(value))regional+=1;
        if(/(?:plug|adapter)/i.test(value))powered+=1;
      });
      if(/(?:plug|adapter)/i.test(name)&&regional>0)return index;
      if(regional>=2&&powered>=2)return index;
    }
    return-1;
  }
  function commonVariants(product){
    return (product&&Array.isArray(product.variants)?product.variants:[]).map(function(raw){
      return{id:String(raw.id||''),available:available(raw),options:variantOptions(raw),raw:raw};
    });
  }
  function findRegionalVariant(product,seed,region){
    var variants=commonVariants(product);
    if(!variants.length||!region)return null;
    var plugIndex=detectPlugIndex(product,product.variants||[]);
    if(plugIndex<0)return null;
    var seedCommon=seed&&seed.options?seed:null;
    if(seedCommon&&seedCommon.raw==null)seedCommon={id:String(seed.id||''),available:available(seed),options:variantOptions(seed),raw:seed};
    if(!seedCommon)seedCommon=variants.filter(function(item){return item.available;})[0]||variants[0];
    if(!seedCommon)return null;
    var seedBase=baseValue(seedCommon.options[plugIndex]||'');
    var candidates=variants.filter(function(item){
      if(!item.available||regionFromValue(item.options[plugIndex]||'')!==region)return false;
      for(var index=0;index<Math.max(item.options.length,seedCommon.options.length);index+=1){
        if(index===plugIndex)continue;
        if(text(item.options[index])!==text(seedCommon.options[index]))return false;
      }
      if(seedBase&&baseValue(item.options[plugIndex]||'')!==seedBase)return false;
      return true;
    });
    return candidates[0]||null;
  }
  function variantById(product,id){
    var variants=commonVariants(product);
    return variants.filter(function(item){return String(item.id)===String(id);})[0]||null;
  }
  function firstAvailable(product){
    var variants=commonVariants(product);
    return variants.filter(function(item){return item.available;})[0]||variants[0]||null;
  }
  function rewriteVariantHref(link,variantId){
    if(!link||!variantId)return;
    var href=link.getAttribute('href');
    if(!href||href.charAt(0)==='#')return;
    try{
      var url=new URL(href,window.location.origin);
      if(url.origin!==window.location.origin)return;
      url.searchParams.set('variant',String(variantId));
      link.setAttribute('href',url.pathname+url.search+url.hash);
    }catch(error){}
  }
  function safeJson(node){
    try{return node?JSON.parse(node.textContent||''):null;}catch(error){return null;}
  }

  function syncPlugCaption(group,root,explicitVariant){
    if(!group)return;
    var caption=group.querySelector('.sh-plug-disclosure__title small');
    if(!caption)return;
    var region=preferredRegion(root);
    var checked=group.querySelector('input[data-variant-input]:checked');
    var selectedRegion=regionFromValue(checked&&checked.value);
    if(!region){caption.textContent='Choose the plug you need';return;}
    if(selectedRegion===region&&!explicitVariant){
      caption.textContent='Selected for '+(root.dataset.countryName||'your region');
    }else if(selectedRegion===region){
      caption.textContent='Selected option';
    }else{
      caption.textContent='Choose the plug you need';
    }
  }

  function currentPdpVariant(root,variants){
    var checked=Array.prototype.slice.call(root.querySelectorAll('input[data-variant-input]:checked'));
    if(checked.length){
      checked.sort(function(a,b){
        var ai=Number(String(a.dataset.index||'').replace(/\D/g,''))||0;
        var bi=Number(String(b.dataset.index||'').replace(/\D/g,''))||0;
        return ai-bi;
      });
      var values=checked.map(function(input){return input.value;});
      var match=variants.filter(function(variant){
        var options=variantOptions(variant);
        return options.length===values.length&&options.every(function(value,index){return String(value)===String(values[index]);});
      })[0];
      if(match)return match;
    }
    var active=root.dataset.shActiveVariantId;
    return variants.filter(function(variant){return String(variant.id)===String(active);})[0]||variants[0]||null;
  }

  function applyPdp(root){
    if(!root||!root.querySelector)return;
    var group=root.querySelector('[data-sh-option][data-option-semantic="plug"]');
    if(!group)return;
    var explicitVariant=false;
    try{explicitVariant=new URL(window.location.href).searchParams.has('variant');}catch(error){}
    if(root.dataset.shRegionalAdapterApplied==='true'){
      syncPlugCaption(group,root,false);
      return;
    }
    root.dataset.shRegionalAdapterApplied='true';
    var region=preferredRegion(root);
    if(!region){syncPlugCaption(group,root,false);return;}
    var meta=safeJson(root.querySelector('[data-sh-variant-meta]'));
    if(!Array.isArray(meta)||!meta.length){syncPlugCaption(group,root,false);return;}
    var optionIndex=Number(String(group.dataset.optionIndex||'').replace(/\D/g,''))-1;
    if(optionIndex<0){syncPlugCaption(group,root,false);return;}
    var product={options:[],variants:meta};
    product.options[optionIndex]={name:group.dataset.optionName||'Plug type'};
    var seedRaw=currentPdpVariant(root,meta);
    var seed=seedRaw?{id:String(seedRaw.id||''),available:available(seedRaw),options:variantOptions(seedRaw),raw:seedRaw}:null;
    var target=findRegionalVariant(product,seed,region);
    if(!target){syncPlugCaption(group,root,false);return;}
    var targetValue=target.options[optionIndex];
    var targetInput=Array.prototype.slice.call(group.querySelectorAll('input[data-variant-input]')).filter(function(input){
      return String(input.value)===String(targetValue)&&input.getAttribute('aria-disabled')!=='true';
    })[0];
    if(targetInput&&!targetInput.checked){
      targetInput.checked=true;
      targetInput.dispatchEvent(new Event('change',{bubbles:true}));
    }
    window.setTimeout(function(){syncPlugCaption(group,root,false);},0);
    if(group.dataset.shRegionalCaptionReady!=='true'){
      group.dataset.shRegionalCaptionReady='true';
      group.addEventListener('change',function(event){
        if(event.target&&event.target.matches('input[data-variant-input]'))window.setTimeout(function(){syncPlugCaption(group,root,true);},0);
      });
    }
  }

  function applyUniversalCard(card){
    if(!card||!card.querySelector)return;
    var node=card.querySelector('[data-sh-uc-product-json]');
    var product=safeJson(node);
    if(!product||!Array.isArray(product.variants)||!product.variants.length)return;
    var region=preferredRegion(card);
    if(!region)return;
    var seed=variantById(product,card.dataset.selectedVariantId)||firstAvailable(product);
    var target=findRegionalVariant(product,seed,region);
    if(!target)return;
    card.dataset.selectedVariantId=String(target.id);
    card.querySelectorAll('[data-sh-uc-quick]').forEach(function(button){button.dataset.selectedVariantId=String(target.id);});
    card.querySelectorAll('a[href*="/products/"]').forEach(function(link){rewriteVariantHref(link,target.id);});
  }

  function reorderRawProduct(product,region){
    if(!product||!Array.isArray(product.variants)||!product.variants.length||!region)return'';
    var seed=firstAvailable(product);
    var target=findRegionalVariant(product,seed,region);
    if(!target)return'';
    var index=-1;
    for(var i=0;i<product.variants.length;i+=1){if(String(product.variants[i].id)===String(target.id)){index=i;break;}}
    if(index>0){var raw=product.variants.splice(index,1)[0];product.variants.unshift(raw);}
    return String(target.id);
  }

  function applyLegacyDataNode(node){
    if(!node)return{};
    var data=safeJson(node);
    var products=Array.isArray(data)?data:(data?[data]:[]);
    if(!products.length)return{};
    var region=preferredRegion(node.closest(LEGACY_ROOT)||node);
    if(!region)return{};
    var targets={};
    var changed=false;
    products.forEach(function(product){
      var id=reorderRawProduct(product,region);
      if(id&&product.handle){targets[String(product.handle)]=id;changed=true;}
    });
    if(changed){
      try{node.textContent=JSON.stringify(data);node.dataset.shRegionalAdapterReady='true';}catch(error){}
    }
    return targets;
  }

  function applyLegacyRoot(root){
    if(!root||!root.querySelectorAll)return;
    var targets={};
    root.querySelectorAll(LEGACY_DATA).forEach(function(node){
      var found=applyLegacyDataNode(node);
      Object.keys(found).forEach(function(handle){targets[handle]=found[handle];});
    });
    Object.keys(targets).forEach(function(handle){
      root.querySelectorAll('[data-handle="'+handle.replace(/"/g,'')+'"] a[href*="/products/"]').forEach(function(link){rewriteVariantHref(link,targets[handle]);});
    });
  }

  function boot(scope){
    var root=scope&&scope.querySelectorAll?scope:document;
    if(root.matches&&root.matches('.sh-studio'))applyPdp(root);
    root.querySelectorAll('.sh-studio').forEach(applyPdp);
    if(root.matches&&root.matches('[data-sh-uc-card]'))applyUniversalCard(root);
    root.querySelectorAll('[data-sh-uc-card]').forEach(applyUniversalCard);
    if(root.matches&&root.matches(LEGACY_ROOT))applyLegacyRoot(root);
    root.querySelectorAll(LEGACY_ROOT).forEach(applyLegacyRoot);
  }
  function schedule(scope){
    window.clearTimeout(bootTimer);
    bootTimer=window.setTimeout(function(){boot(scope||document);},0);
  }

  document.addEventListener('click',function(event){
    var trigger=event.target&&event.target.closest?event.target.closest('button[data-sh-quick],button[data-quick-add]'):null;
    if(!trigger||trigger.closest('[data-sh-universal-grid]'))return;
    var root=trigger.closest(LEGACY_ROOT);
    if(root)applyLegacyRoot(root);
  },true);

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});
  else boot(document);
  window.addEventListener('pageshow',function(){boot(document);});
  document.addEventListener('shopify:section:load',function(event){boot(event.target||document);});

  var observer=new MutationObserver(function(mutations){
    var shouldRun=false;
    mutations.forEach(function(mutation){
      if(shouldRun)return;
      Array.prototype.forEach.call(mutation.addedNodes||[],function(node){
        if(shouldRun||node.nodeType!==1)return;
        if((node.matches&&(node.matches('.sh-studio,[data-sh-uc-card],'+LEGACY_ROOT+','+LEGACY_DATA)))||(node.querySelector&&node.querySelector('.sh-studio,[data-sh-uc-card],'+LEGACY_ROOT+','+LEGACY_DATA)))shouldRun=true;
      });
    });
    if(shouldRun)schedule(document);
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});

  window.SickHausRegionalAdapter={country:countryCode,preferred:preferredRegion};
})();
